import styled from 'styled-components'

const FooterContainer = styled.div`
    margin-top: 35px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 88%;
    flex-shrink: 0;
`

export default FooterContainer
